export default {
  buttons: {
    cancel: "Cancelar",
    dismiss: "Fechar",
    add_waypoint: "Adicionar destino"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Pesquisar",
    placeholder: "Insira uma localização",
    enter_location: "Insira uma localização",
    geolocation: "Usar minha localização",
    help: {
      inactive: "Pesquisar"
    }
  },
  filters: {
    title: "Filtros",
    amenities: {
      title: "Serviços"
    },
    fuels: {
      title: "Tipos de combustíveis"
    }
  },
  directions: {
    title: "Planejador de rota",
    placeholder: {
      destination: "Insira uma localização",
      waypoint: "Insira uma localização"
    },
    route: {
      title: "Opções de rota",
      avoid_tolls: "Evitar estradas pedagiadas",
      avoid_highways: "Evitar auto-estradas",
      title_corridor: "Distância até o posto de combustível"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# dia} other {# dias}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Pesquisar"
  },
  locations: {
    title: "Localizações",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} de {place}"
  },
  open_now: {
    open_24_hours: "Aberto 24 horas"
  },
  info_window: {
    title: "Detalhes do site",
    services: "Serviços",
    nearby: "Próximo",
    opening_hours: {
      title: "Horário de funcionamento",
      mon: "Seg",
      tue: "Ter",
      wed: "Qua",
      thu: "Qui",
      fri: "Sex",
      sat: "Sab",
      sun: "Dom",
      open_twentyfourhours: "Aberto 24 horas",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Última atualização",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Planejador de rota"
  },
  amenities: {
    air_and_water: "Ar",
    bank_note_acceptor: "Banco 24h",
    carwash: "Lava Jato",
    credit_card_american_express: "Cartão de crédito - American Express",
    credit_card_diners_club: "Cartão de crédito - Dinners Club",
    credit_card_mastercard: "Cartão de crédito - Mastercard",
    credit_card_visa: "Cartão de crédito - Visa",
    credit_card: "Cartão de crédito",
    euroshell_card: "Cartão Shell Santander",
    food_offerings: "Alimentos oferecidos",
    quick_lubes: "Troca de óleo",
    restaurant: "Restaurante",
    shell_card: "Cartão Shell Santander",
    shop: "Loja de conveniência",
    shower: "Ducha",
    snack_food: "Lanches",
    standard_toilet: "Banheiro",
    supermarket_fuel_discount: "Desconto de combustível",
    toilet: "Banheiro",
    truck_parking: "Estacionamento de caminhão",
    twenty_four_hour: "24 horas",
    wifi: "Wi-fi"
  },
  settings: {
    title: "Configurações",
    tooltip: "Configurações",
    distance_units: {
      title: "Distância",
      km: "Quilômetros",
      miles: "Milhas"
    },
    language: {
      title: "Idioma"
    }
  },
  geolocation: {
    tooltip: "Usar minha localização"
  }
}
